<img [src]="img" alt="Equipo" role="button" (click)="usuariosEquipo()">
